import React, { useEffect, useRef, useState } from 'react'
import CalendarIcon from '../../../../icons/calendar.svg'
import Calendar from 'react-calendar'
import moment from 'moment/moment'
import styles from '../../../Pages/Common/Footer/footer.module.scss'
import RightArrow from '../../../../icons/rightArrowIcon.svg'
import LeftArrow from '../../../../icons/leftArrowIcon.svg'
import AttachFile from '../../../../icons/attach.svg'
import { useDispatch, useSelector } from 'react-redux'
import { setCareReceipients } from '../../../../redux/actions/careReceipients'
import { setCareQuizQuestions } from '../../../../redux/actions/quizQuestions'
import ArrowBtn from '../../../../icons/arrowBtn.svg'
import { insuranceCompanies } from '../../../../constants/lists/relationshipList'
import cx from 'classnames'
import { uploadFile } from '../../../../api/formApi'
import PhoneNumberField from '../../../ReusableField/PhoneNumberField'
import { handlePhoneNumberFieldChange } from '../../../../redux/actions/Auth'
import { calculateAge, countryPhoneDetails } from '../../../../constant/constants'
import countryPickerData from '../../../../constant/countryPickerData'
const QuizCareReceipients = ({ parentState, setParentState }) => {
  const currentDate = new Date()
  const [fileName, setFileName] = useState('')
  const {
    quizCareReceipients: { quizCare, indexCare },
  } = useSelector((state) => state.quizQuestions)
  const {
    careReceipients,
    payment: { reimbursementRef },
  } = useSelector((state) => state)
  const { phoneNumberObj } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const [showCalendar, setShowCalendar] = useState(false)
  const [option, setOption] = useState(false)
  const wrapperRef = useRef(null)
  const wrapper = useRef(null)
  const inputRef = useRef(null)
  const buttonGroupRef = useRef(null) // Move this to your component scope
  useEffect(() => {
    document.addEventListener('click', handleClickOutside, false)
    return () => {
      document.removeEventListener('click', handleClickOutside, false)
    }
  }, [])
  useEffect(() => {
    document.addEventListener('click', handleClickOut, false)
    return () => {
      document.removeEventListener('click', handleClickOut, false)
    }
  }, [])

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setOption(false)
    }
  }
  const handleClickOut = (event) => {
    if (wrapper.current && !wrapper.current.contains(event.target)) {
      setShowCalendar(false)
    }
  }
  const handleChange = (e) => {
    setParentState(e.currentTarget.value)
  }
  const handleChangeNumber = (e) => {
    if (/^\d*$/.test(e.currentTarget.value)) {
      if (e.currentTarget.value.length <= 5) {
        setParentState(e.currentTarget.value)
      }
    }
  }
  const handleChangePhone = (newPhoneNumberObj) => {
    dispatch(handlePhoneNumberFieldChange(newPhoneNumberObj))
  }
  const clickOption = () => {
    if (!option) {
      setOption(true)
    } else {
      setOption(false)
    }
  }

  const clickCareOption = (e) => {
    setParentState(e.target.innerText)
    setOption(false)
  }
  const handleFile = (e) => {
    const file = e.target.files[0]
    if (!file) {
      console.log('No file selected')
      return
    }
    const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf']
    if (!allowedFileTypes.includes(file.type)) {
      console.log('Unsupported file type. Please select a JPEG, PNG, or PDF.')
      return
    }
    const maxSizeInBytes = 5 * 1024 * 1024 // 5MB
    if (file.size > maxSizeInBytes) {
      console.log('File size exceeds 5MB.')
      return
    }

    let formData = new FormData()
    formData.append('file', file)
    uploadFile(formData, reimbursementRef, 'RC_CARE_RECIPIENT')
      .then((res) => {
        setParentState(res.amazonUrl) // Update the parent state
      })
      .catch((error) => {
        console.error('Upload failed:', error)
      })

    // Update file name in UI
    setFileName(file.name)
    file.name && inputRef.current.focus()
  }
  const handleChangeCalendar = (e) => {
    setParentState(moment(e).format('DD.MM.YYYY'))
    setShowCalendar(false)
  }
  const convertToDate = (dateString) => {
    const [day, month, year] = dateString.split('.')
    const date = new Date(year, month - 1, day)
    return date.toString()
  }
  const handleCareAnswer = () => {
    if (!parentState) return
    const newQuiz = quizCare.map((item, i) => {
      if (i === indexCare) {
        console.log(item.question, parentState)
        return {
          ...item,
          // answers: parentState,
          answers:
            item.type === 'phoneNumber'
              ? `+${phoneNumberObj.callingCode} ` + '' + `${parentState}`
              : parentState,
          returnQuestion:
            item.question ===
              'Wurde bereits ein Pflegegrad erteilt ? Wenn ja, welcher ? Bitte wählen Sie aus der Liste aus.' &&
            (parentState === 'Nein' || parentState === '1')
              ? 'Ersatz von Kosten der Verhinderungspflege ist derzeit nicht möglich, mindestens Pflegegrad 2 ist erforderlich.'
              : calculateAge(convertToDate(parentState)) < 25
                ? 'Bitte beachten Sie : Bei Antragstellern mit Pflegegrad 4 oder 5 bis einschliesslich 25 Jahre kann die Berechnung Fehler aufweisen.'
                : '',
          returnLink:
            item.question ===
              'Wurde bereits ein Pflegegrad erteilt ? Wenn ja, welcher ? Bitte wählen Sie aus der Liste aus.' &&
            (parentState === 'Nein' || parentState === '1')
              ? 'https://flexxi.care/de/vhp#faq'
              : null,
          fileName: fileName,
        }
      }
      return item
    })
    dispatch(
      setCareReceipients(
        Object.keys(careReceipients)[indexCare],
        Object.keys(careReceipients)[indexCare] === 'phoneNumber'
          ? `+${phoneNumberObj.callingCode} ` + '' + `${parentState}`
          : parentState,
      ),
    )
    // dispatch(setIndex(index + 1))
    dispatch(setCareQuizQuestions(newQuiz, indexCare + 1))
    dispatch(
      handlePhoneNumberFieldChange({
        countryCode: 'DE',
        callingCode: '49',
        number: '',
      }),
    )
    setParentState('')
  }

  const handleShowCalendar = () => {
    if (!showCalendar) {
      setShowCalendar(true)
    } else {
      setShowCalendar(false)
    }
  }
  const handleClick = (e) => {
    const buttons = buttonGroupRef.current?.querySelectorAll('input[type="submit"]')
    buttons?.forEach((btn) => btn.classList.remove(styles.active))
    e.target.classList.add(styles.active)
    handleChange(e) // Your original handler
  }
  const maxYear = new Date().getFullYear()

  const formatDate = (value) => {
    value = value.replace(/[^\d.]/g, '')

    if (value.length > 10) return parentState

    let parts = value.split('.')
    let day = parts[0] || ''
    let month = parts[1] || ''
    let year = parts[2] || ''

    if (day.length > 2) {
      month = day.slice(2) + (month ? '.' + month : '')
      day = day.slice(0, 2)
    }
    if (Number(day) > 31) day = '31'

    // Format month (01-12)
    if (month.length > 2) {
      year = month.slice(2) + (year ? '.' + year : '')
      month = month.slice(0, 2)
    }
    if (Number(month) > 12) month = '12'

    if (year.length > 4) year = year.slice(0, 4)
    if (year && Number(year) > maxYear) year = maxYear.toString()

    let formattedDate = day
    if (month) formattedDate += '.' + month
    if (year) formattedDate += '.' + year

    return formattedDate
  }
  const cleanedInput = parentState?.trim() || ''
  const isValidDate = (value) => {
    const parts = value.split('.')
    if (parts.length !== 3) return false

    const [day, month, year] = parts.map(Number)

    return (
      day >= 1 &&
      day <= 31 &&
      month >= 1 &&
      month <= 12 &&
      year >= 1000 &&
      year <= 9999 // Only allow 4-digit year
    )
  }

  const endsWithPDF = (value) => {
    return value.slice(-3).toLowerCase() === 'pdf'
  }

  const isButtonDisabled = !(
    (quizCare[indexCare]?.type === 'birthday'
      ? parentState?.length === 10 && isValidDate(parentState)
      : quizCare[indexCare]?.type === 'number'
        ? parentState?.length === 5
        : parentState) || endsWithPDF(cleanedInput)
  )
  const handleChangeBirthday = (e) => {
    const newValue = formatDate(e.currentTarget.value)
    setParentState(newValue)
  }
  return (
    <>
      {quizCare?.map((item, i) => {
        if (i === indexCare) {
          switch (item?.type) {
            case 'text':
              return (
                <input
                  type={'text'}
                  pattern=""
                  placeholder={'Geben Sie eine Antwort ein.'}
                  value={parentState}
                  onChange={(e) => handleChange(e)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && parentState) handleCareAnswer()
                  }}
                  key={i}
                  autoFocus={true}
                />
              )
            case 'number':
              return (
                <input
                  type={item.questionKey === 'insuranceNumber' ? 'text' : 'number'}
                  pattern=""
                  placeholder={'Geben Sie eine Antwort ein.'}
                  value={parentState}
                  onChange={(e) => handleChangeNumber(e)}
                  onKeyDown={(e) => {
                    if (
                      e.key === 'Enter' &&
                      parentState &&
                      parentState?.length === 5
                    )
                      handleCareAnswer()
                  }}
                  key={i}
                  autoFocus={true}
                />
              )
            case 'phoneNumber':
              return (
                <PhoneNumberField
                  onChange={handleChangePhone}
                  phoneNumberObj={phoneNumberObj}
                  setAnswerr={setParentState}
                  handleonKeyDown={handleCareAnswer}
                />
              )
            case 'birthday':
              return (
                <div>
                  <input
                    placeholder="Datum auswählen"
                    value={parentState}
                    required
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && !isButtonDisabled) handleCareAnswer()
                    }}
                    key={i}
                    autoFocus={true}
                    className={cx({ [styles.bDay]: parentState })}
                    onChange={(e) => handleChangeBirthday(e)}
                  />
                  <img
                    src={CalendarIcon}
                    alt={CalendarIcon}
                    onClick={handleShowCalendar}
                  />
                  {!!showCalendar && (
                    <Calendar
                      onChange={(e) => handleChangeCalendar(e)}
                      value={
                        !parentState || parentState.length !== 10
                          ? new Date(1965, moment().month(), moment().date())
                          : convertToDate(parentState)
                      }
                      maxDate={new Date()}
                      className={styles.reactCalendar}
                      nextLabel={<img src={RightArrow} alt={'next'} />}
                      prevLabel={<img src={LeftArrow} alt={'Previous'} />}
                      next2Label={null}
                      prev2Label={null}
                      tileDisabled={({ date, view }) => {
                        if (view === 'year') {
                          return (
                            date.getFullYear() > currentDate.getFullYear() ||
                            (date.getFullYear() === currentDate.getFullYear() &&
                              date.getMonth() > currentDate.getMonth())
                          )
                        }
                        return false
                      }}
                      locale="de"
                    />
                  )}
                </div>
              )
            case 'option':
              return (
                <div className={styles.optionHid}>
                  <div
                    className={cx(styles.select, {
                      [styles.placeholder]: parentState,
                    })}
                    onClick={clickOption}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && parentState) handleCareAnswer()
                    }}
                    key={i}
                    ref={wrapperRef}
                  >
                    {parentState ? parentState : 'Bitte wählen Sie'}
                  </div>
                  {!!option && (
                    <div className={styles.option}>
                      {insuranceCompanies
                        .sort((a, b) => a.localeCompare(b))
                        .map((item) => {
                          return <div onClick={clickCareOption}>{item}</div>
                        })}
                    </div>
                  )}
                </div>
              )
            case 'rate':
              return (
                <div ref={buttonGroupRef} className={styles.submitBtn}>
                  <input type={'submit'} value={'Nein'} onClick={handleClick} />
                  <input type={'submit'} value={1} onClick={handleClick} />
                  <input type={'submit'} value={2} onClick={handleClick} />
                  <input type={'submit'} value={3} onClick={handleClick} />
                  <input type={'submit'} value={4} onClick={handleClick} />
                  <input type={'submit'} value={5} onClick={handleClick} />
                </div>
              )
            case 'submit':
              return (
                <span ref={buttonGroupRef}>
                  <input
                    type="submit"
                    value="Ja"
                    onClick={handleClick}
                    className={cx(styles.care)}
                  />
                  <input
                    type="submit"
                    value="Nein"
                    onClick={handleClick}
                    className={cx(styles.care)}
                  />
                </span>
              )
            case 'file':
              return (
                <>
                  <span className={styles.imageUpload}>
                    <label htmlFor="file-input">
                      <img src={AttachFile} alt="Attach File" />
                    </label>
                    <input
                      id="file-input"
                      type="file"
                      onChange={handleFile}
                      accept="image/jpeg,image/png,.pdf"
                    />
                  </span>
                  <input
                    type="text"
                    placeholder="Datei anhängen"
                    value={fileName}
                    className={styles.attach}
                    readOnly
                    ref={inputRef}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && parentState) handleCareAnswer()
                    }}
                  />
                </>
              )
          }
        }
      })}
      {quizCare.length !== indexCare && (
        <button
          disabled={isButtonDisabled}
          className={cx({
            [styles.btnDisabled]: isButtonDisabled,
          })}
          onClick={handleCareAnswer}
        >
          <img src={ArrowBtn} alt={ArrowBtn} />
        </button>
      )}
    </>
  )
}

export default QuizCareReceipients
